// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"561d8455","163":"e6c059a4","353":"9b14d6c2","410":"d6dc6eca","648":"d55d2e8e","858":"a720642f","992":"3a595066"}[chunkId] + ".chunk.css";
};